import type { TripItineraryItem, TripItemWithoutDay, TripStop } from 'tripPlanner/api/types'
import { getStopHotelItems } from 'tripPlanner/utils/chatItinerary'

type AccommodationEntry = {
  item: TripItineraryItem | TripItemWithoutDay
  dayDate?: string
}

/** Use the same stays and ordering as the hotel drawer, retaining their day context. */
export function getStopAccommodationItems(stop: TripStop | undefined): Array<AccommodationEntry> {
  return getStopHotelItems(stop).map(item => ({
    item,
    dayDate: stop?.days.find(day => day.items.some(dayItem => dayItem === item))?.date,
  }))
}
